{
  "header": "<h2>{{name}}, here is your offer for the purchase of <payment />!</h2>",
  "header-expired": {
    "name": "<h2>{{name}}, do you need time to decide?</h2>",
    "no-name": "<h2>Do you need time to decide?</h2>"
  },
  "subheader": "A down payment is due today, then pay the remaining balance in monthly installments.",
  "subheader-zero-down": "$0 due today! Then pay the total balance in monthly installments.",
  "subheader-zero-down-onboard-spend": "Pay as little as $0 today, then pay the balance in monthly installments.",
  "subheader-delayed-payments": "Delayed payment options available.",
  "inputs-header": "Billing Details",
  "required-fields": "All fields required",
  "select-payment-method": "Select payment method",
  "payment-option": {
    "debit": "Debit card",
    "bank-account": "Add your bank account",
    "bank-account-desc": "Connect your bank account for more convenience and reliability. Set it and forget it!",
    "credit": "Credit Card"
  },
  "payment-faq-button": "What are my payment method options?",
  "select-payment-method-error": "You must select a payment method",
  "plaid-locked-error": "Please select a different payment method.",
  "plaid-link-token-error": "Oops! Something went wrong. Please try again or select a different payment method.",
  "recommended": "Recommended",
  "offerSelector": {
    "srOnly": {
      "multipleOfferSelectedTitle": "Selected Installment Payment Offer {{index}}",
      "multipleOfferTitle": "Installment Payment Offer {{index}}",
      "singleOfferTitle": "Installment Payment Offer",
      "apr": "A P R ",
      "remainingPayments": "Remaining number of payments: "
    },
    "perMonth": " /month",
    "monthly": "monthly",
    "zeroDown": "$0 due today!",
    "payToday": "+ down payment today of <downPayment />",
    "apr": "APR",
    "interest": "Interest",
    "total": "Total",
    "months": " months",
    "tooltip": "<div><strong>Your 1 payment today includes:</strong><table><tbody><tr><td>Origination fee</td><td><originationFee /></td></tr><tr><td>Downpayment</td><td><pureDownPayment /></td></tr></tbody></table><br><strong>Followed by {{numberOfPayments}} monthly installments</strong></div>",
    "deferredPayment": {
      "text": "First installment Jan 2023",
      "mobile": {
        "firstInstallment": "First installment",
        "date": "Jan 2023"
      }
    },
    "delayedPayments_other": "Payments start in <strong> {{count}} </strong> months",
    "delayedPayments_one": "Payments start in <strong> {{count}} </strong> month",
    "delayedPaymentsMobile": {
      "paymentsStartsIn": "Payments start in",
      "months_one": "<strong> {{count}} </strong> month",
      "months_other": "<strong> {{count}} </strong> months"
    },
    "zeroAPRLabel": "0% APR",
    "lowestPaymentLabel": "Lowest Monthly Payment"
  },
  "inputs": {
    "card-info-name": {
      "isRequired": true,
      "label": "Cardholder Name*",
      "validity": [
        ["required", "Cardholder Name is required*", "ignore label"],
        ["minLength1", "Enter name as it appears on card*", "ignore label"]
      ]
    },
    "card-info-number": {
      "isRequired": true,
      "label": "Card Number*",
      "validity": [
        ["isValidCardNumberEn", "Invalid Card Number*", "ignore label"]
      ]
    },
    "card-info-expiration": {
      "isRequired": true,
      "label": "Exp*",
      "mask": "99/99",
      "maxLength": 6,
      "format": "mmyyyy",
      "placeholder": "MM/YY",
      "srOnly": "M M Y Y",
      "validity": [["isValidCardExpiration", "Invalid Date*", "ignore label"]]
    },
    "card-info-ccv": {
      "label": "CVC*",
      "isRequired": true,
      "tooltip": "<div>3 or 4-digit number located on the back of the card.</div>",
      "validity": [["isValidCardCCV", "Invalid code*", "ignore label"]]
    },
    "billing-zip": {
      "label": "ZIP Code*",
      "isRequired": true,
      "mask": "X9X 9X9",
      "validity": [["isValidCardZip", "Invalid ZIP Code*", "ignore label"]]
    },
    "full-ssn": {
      "label": "Social Security Number*",
      "isRequired": true,
      "placeholder": "***-**-****",
      "mask": "000-00-0000",
      "allowHide": true,
      "allow-hide-label": "Show your full SSN",
      "tooltip": "<div><span>We need this to verify</span><br><span>your identity.</span></div>",
      "validity": [
        ["required", "Social Security Number is required*", "ignore label"],
        [
          "requiredLength9",
          "Social Security Number is invalid*",
          "ignore label"
        ]
      ],
      "postProcess": "digitOnlyString"
    },
    "autopay": {
      "isRequired": true,
      "validity": []
    }
  },
  "autopay": {
    "label": "Enable AutoPay",
    "content": "<span>AutoPay is an easy and convenient way to make your monthly loan payments.</span>",
    "modalContent": {
      "header": "Are you sure?",
      "body": "AutoPay is a convenient and simple way to make your monthly loan payments and helps ensure you don’t have an extra interest expense from late payments.",
      "keep": "Keep AutoPay",
      "disable": "Disable AutoPay"
    }
  },
  "edit": "Edit",
  "submit": "Continue",
  "uplift": {
    "terms": ""
  },
  "flexpay": {
    "terms": "",
    "offerSelector": {
      "delayedPayments": {
        "multi": "Payments start in {{months}} months",
        "single": "Payments start in {{months}} month"
      }
    }
  },
  "splitOfferSelector": {
    "selectedOffer": {
      "dueToday": "Due Today",
      "interestWithAPR": "Interest (<APRComponent/> APR)",
      "selectedOffer": "Selected Offer"
    },
    "changePaymentPlan": {
      "paymentPlan": "Payment Plan",
      "change": "Change"
    }
  }
}
